import { ConstantModel } from "@core/models/outros/constant.model";

export const FINANCIAL_PEOPLE_ADDRESS: ConstantModel[] = [
  {
    id: 1,
    descricao: 'FATURAMENTO',
    enum: '1',
  },
  {
    id: 2,
    descricao: 'COBRANÇA',
    enum: '2',
  },
  {
    id: 3,
    descricao: 'CORRESPONDÊNCIA',
    enum: '3',
  },
]
